import { ReadProjectSchedule } from "@/types/projectSchedule";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ColumnDef } from "@tanstack/react-table";

export const useProjectSchedulesStoresColumns = (): Record<
  string,
  ColumnDef<ReadProjectSchedule>
> => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      store_status: {
        id: "store_status",
        cell: ({ row }) => t(`storeStatuses.${row.original.store_status}`),
      },
      project_status: {
        id: "project_status",
        cell: ({ row }) => t(`projectStatuses.${row.original.project_status}`),
      },
      settlement_type: {
        id: "settlement_type",
        cell: ({ row }) => t(`settlementType.${row.original.settlement_type}`),
      },
    }),
    [t],
  );
};
